// KPIs (model outputs) hidden from every user by the model's Display settings. Stored on the
// client doc as `hidden_kpis: string[]`; a missing or empty list shows every KPI. Every view
// that offers a KPI selector, or falls back to "the first output", reads through these helpers
// so a hidden KPI never surfaces anywhere.

// The list of hidden output names of a client (model) doc, never null.
export function hiddenKpis (client) {
  return (client && Array.isArray(client.hidden_kpis)) ? client.hidden_kpis : []
}

export function isKpiHidden (client, name) {
  return hiddenKpis(client).indexOf(name) !== -1
}

// Whether any KPI is hidden. The Total is the sum of every output, hidden ones included, so
// callers drop the Total option when this is true (Total minus the visible KPIs would reveal
// the hidden ones).
export function hasHiddenKpis (client) {
  return hiddenKpis(client).length > 0
}

// The given output names without the hidden ones, keeping their order.
export function visibleOutputNames (client, names) {
  const hidden = hiddenKpis(client)
  return (names || []).filter(name => hidden.indexOf(name) === -1)
}

// The first visible output name of an `outputs` map, or null when none is visible (or there is
// no map). Replaces the `Object.keys(outputs)[0]` fallbacks.
export function firstVisibleOutputName (client, outputs) {
  if (!outputs) return null
  const visible = visibleOutputNames(client, Object.keys(outputs))
  return visible.length > 0 ? visible[0] : null
}
